export const UNKNOWN_ERROR = 'An unknown error has occurred, please try again later';

export const hasError = (response: any): boolean => {
  return !response || !response.data || response.errors;
};

export const parseError = (response: any): string | undefined => {
  if (!hasError(response)) {
    return undefined;
  }

  let error = Array.isArray(response.errors) ? response.errors[0] : response;
  error = parseErrorMessage(error);

  return error || UNKNOWN_ERROR;
};

const parseErrorMessage = (error: any): string | null => {
  let e = error.message || error;
  if (!e) {
    return null;
  }

  e = /^(GraphQL\.ExecutionError: |GraphQL error: GraphQL.ExecutionError: |GraphQL error: )/i.test(e)
  ? e.replace(/^(GraphQL\.ExecutionError: |GraphQL error: GraphQL.ExecutionError: |GraphQL error: )/i, '') : e;

  return /exception/i.test(e) ? null : e;
};
